import React from 'react';

const MoreOptionsIcon = (props: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.9996 12.9C12.4967 12.9 12.8996 12.497 12.8996 12C12.8996 11.5029 12.4967 11.1 11.9996 11.1C11.5026 11.1 11.0996 11.5029 11.0996 12C11.0996 12.497 11.5026 12.9 11.9996 12.9Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.2994 12.9C18.7965 12.9 19.1994 12.497 19.1994 12C19.1994 11.5029 18.7965 11.1 18.2994 11.1C17.8024 11.1 17.3994 11.5029 17.3994 12C17.3994 12.497 17.8024 12.9 18.2994 12.9Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.6998 12.9C6.19686 12.9 6.5998 12.497 6.5998 12C6.5998 11.5029 6.19686 11.1 5.6998 11.1C5.20275 11.1 4.7998 11.5029 4.7998 12C4.7998 12.497 5.20275 12.9 5.6998 12.9Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MoreOptionsIcon;
